import type { ComponentType } from "react";
import {
  ErrorModal,
  SuccessModal,
  WalletIntegrationWarningModal,
  WarningModal,
} from "../../shared";

type ComponentRegistry = Map<string, ComponentType<any>>;

const modalRegistry: ComponentRegistry = new Map();

modalRegistry.set("ERROR", ErrorModal);
modalRegistry.set("WARNING", WarningModal);
modalRegistry.set("SUCCESS_MODAL_OPEN", SuccessModal);
modalRegistry.set(
  "WALLET_INTEGRATION_WARNING_MODAL_OPENED",
  WalletIntegrationWarningModal
);

export default modalRegistry;
